
function beforeCall(functionName, ...args) {
  console.debug('Called analytics function:', functionName, ...args);
}

const fbq = window.fbq || function (...args) {
  console.warn("fbq function called", args);
}

export const Analytics = {
  accountCreated() {
    beforeCall(this.accountCreated.name);

    fbq('trackCustom', 'Account_Created');
  },

  zipCodeCheckPassed(value) {
    beforeCall(this.zipCodeCheckPassed.name, value);

    fbq('trackCustom', 'ZipCodeCheck_Passed', {
      zip: value
    });
  },

  zipCodeCheckFailed(value) {
    beforeCall(this.zipCodeCheckFailed.name, value);

    fbq('trackCustom', 'ZipCodeCheck_Failed', {
      zip: value
    });
  },

  orderStep1Passed(selectedService) {
    beforeCall(this.orderStep1Passed.name, selectedService);

    fbq('trackCustom', 'Order_ChooseService_Passed', {
      service: selectedService
    });
  },

  orderStep2Passed(selectedService) {
    beforeCall(this.orderStep2Passed.name, selectedService);

    fbq('trackCustom', 'Order_PackageSelection_Passed', {
      service: selectedService
    });
  },

  orderCheckout(selectedService) {
    beforeCall(this.orderCheckout.name, selectedService);

    fbq('trackCustom', 'Order_OrderPlaced', {
      service: selectedService
    });
  }
}
